// @/api/model/damandManage.js

import config from "@/config";
import http from "@/utils/request";

export default {
	queryByPage: {
		url: `${config.MAIN_URL}/api/v1/airfield/runway/queryByPage`,
		name: "机场跑道分页查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},

	getFileContent: {
		url: `${config.MAIN_URL}/api/v1/airfield/runway/getFileContent`,
		name: "机场跑道文件内容查看",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	listFileName: {
		url: `${config.MAIN_URL}/api/v1/airfield/runway/listFileName`,
		name: "机场跑道文件名下拉",
		get: async function () {
			return await http.get(this.url);
		},
	},

	addAirfieldRunway: {
		url: `${config.MAIN_URL}/api/v1/airfield/runway/addAirfieldRunway`,
		name: '机场跑道新增',
		post: async function (data) {
			return await http.post(this.url, data);
		},
	},

	deleteAirfieldRunway: {
		url: `${config.MAIN_URL}/api/v1/airfield/runway/deleteAirfieldRunway`,
		name: "机场跑道删除",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},


};
